(() => {
  let timer;
  let resetTimer;
  const reset = () => {
    clearTimeout(timer);
    clearTimeout(resetTimer);
    document.documentElement.classList.remove('ww-product-navigation-loading');
  };
  document.addEventListener('click', (event) => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || !window.matchMedia('(min-width: 990px)').matches) return;
    const link = event.target.closest('a[href]');
    if (!link || link.hasAttribute('download') || (link.target && link.target !== '_self')) return;
    const destination = new URL(link.href, location.href);
    if (destination.origin !== location.origin || !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\//i.test(destination.pathname) || (destination.pathname === location.pathname && destination.search === location.search)) return;
    queueMicrotask(() => {
      if (event.defaultPrevented) return;
      reset();
      timer = setTimeout(() => {
        document.documentElement.classList.add('ww-product-navigation-loading');
        resetTimer = setTimeout(reset, 8000);
      }, 1000);
    });
  });
  window.addEventListener('pageshow', reset);
  window.addEventListener('pagehide', reset);
})();
